/** @format */
import MongoDBIcon from '../assets/svg/MongoDB';
import ExpressJSIcon from '../assets/svg/ExpressJS';
import NodeJSIcon from '../assets/svg/NodeJS';
import ReactJSIcon from '../assets/svg/ReactJS';

import Jobs from '../assets/svg/Jobs';
import Skills from '../assets/svg/Skills';
import Miscellaneous from '../assets/svg/Miscellaneous';
import Projects from '../assets/svg/Projects';
import Profile from '../assets/svg/Profile';

// question images
import man from '../assets/questions/man.png';
import woman from '../assets/questions/woman.png';
import cross from '../assets/questions/cross.png';
import hr from '../assets/questions/hr.png';
import suitcase from '../assets/questions/suitcase.png';
import friends from '../assets/questions/friends.png';
import linkedin from '../assets/questions/linkedin.png';
import socialmedia from '../assets/questions/social.png';
import reference from '../assets/questions/reference.png';

// social images
import github from '../assets/social/github.png';
import linkedinIcon from '../assets/social/linkedin.png';
import whatsapp from '../assets/social/whatsapp.png';
import instagram from '../assets/social/instagram.png';

export const SKILL_NAMES = {
  mongodb: {
    title: 'MongoDB',
    experience: { years: 0, months: 12 },
    Icon: MongoDBIcon,
  },
  expressjs: {
    title: 'ExpressJS',
    experience: { years: 0, months: 12 },
    Icon: ExpressJSIcon,
  },
  reactjs: {
    title: 'ReactJS',
    experience: { years: 0, months: 12 },
    Icon: ReactJSIcon,
  },
  nodejs: {
    title: 'NodeJS',
    experience: { years: 0, months: 12 },
    Icon: NodeJSIcon,
  },
};

export const APP_MENU = {
  profile: {
    title: 'Profile',
    Icon: Profile,
    link: '#profile',
  },
  jobs: {
    title: 'Jobs',
    Icon: Jobs,
    link: '#job-experience',
  },
  skills: {
    title: 'Skills',
    Icon: Skills,
    link: '#tech-skills',
  },
  projects: {
    title: 'Projects',
    Icon: Projects,
    link: '#projects',
  },
  more: {
    title: 'More',
    Icon: Miscellaneous,
    link: '#miscellaneous',
  },
};

export const JOB_EXPERIENCE = [
  {
    company: 'Klenty',
    location: 'Chennai, Tamil Nadu',
    tenure: { from: new Date('2023-03-26'), to: new Date('2023-11-16') },
    designation: 'MERN Stack Developer',
    description:
      'Contributed to the development of the Calendar product for Klenty.com, a sales engagement platform that enhances team productivity and closing rates by automating outreach and follow-ups.',
  },
  {
    company: 'Navaantrix',
    location: 'Pune, Maharashtra',
    tenure: { from: new Date('2024-03-21'), to: new Date() },
    designation: 'ReactJS Developer',
    description:
      'Developed a dashboard using ReactJS to display interactive charts powered by ECharts for data analytics. Migrated the initial POC from outdated technologies like jQuery to a modern ReactJS-based implementation.',
  },
  {
    company: 'Hire Me !',
    location: 'India/Remote',
    description:
      'Looking to join your team as a Full Stack Developer to build and scale amazing products. Alternatively, hire me as a Freelancer to bring your dream project to life at an affordable cost.',
  },
];

export const VISIT_QUESTIONS = [
  {
    qid: 'gender',
    question: "What's your gender ?",
    options: [
      {
        oid: 'male',
        img: man,
        title: 'Male',
      },
      {
        oid: 'female',
        img: woman,
        title: 'Female',
      },
      {
        oid: 'ignored',
        img: cross,
        title: 'Not prefer to say',
      },
    ],
  },
  {
    qid: 'visitpurpose',
    question: "What's your purpose of visit ?",
    options: [
      {
        oid: 'hiring',
        img: hr,
        title: 'HR / Hiring',
      },
      {
        oid: 'project',
        img: suitcase,
        title: 'Create a project',
      },
      {
        oid: 'friend',
        img: friends,
        title: 'A Friend or I know you',
      },
    ],
  },
  {
    qid: 'linksource',
    question: 'How did you find this website ?',
    options: [
      {
        oid: 'socialmedia',
        img: socialmedia,
        title: 'Social Media',
      },
      {
        oid: 'jobportal',
        img: linkedin,
        title: 'Job Portal',
      },
      {
        oid: 'referral',
        img: reference,
        title: 'Referral',
      },
    ],
  },
];

export const SOCIAL_LINKS = {
  instagram: {
    title: 'Instagram',
    link: 'https://www.instagram.com/developer.inside',
    img: instagram,
  },
  whatsapp: {
    title: 'WhatsApp',
    link: 'https://wa.me/918554855887',
    img: whatsapp,
  },
  github: {
    title: 'Github',
    link: 'https://github.com/maitrikatta',
    img: github,
  },
  linkedin: {
    title: 'LinkedIn',
    link: 'https://www.linkedin.com/in/yogeshkakde',
    img: linkedinIcon,
  },
};
